import type { LanguageCode } from '@/types/api';

/**
 * Language display labels for UI
 * Used in LanguageSwitcher dropdown
 */
export const LANGUAGE_LABELS: Record<LanguageCode, string> = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  pt: 'Português',
  'pt-BR': 'Português (Brasil)',
  tr: 'Türkçe',
};

/**
 * All supported language codes
 */
export const SUPPORTED_LANGUAGES: LanguageCode[] = [
  'en',
  'es',
  'de',
  'fr',
  'it',
  'pt',
  'pt-BR',
  'tr',
];

/**
 * Default UI language
 */
export const DEFAULT_LANGUAGE: LanguageCode = 'en';

/**
 * Get display label for a language code
 */
export function getLanguageLabel(code: LanguageCode): string {
  return LANGUAGE_LABELS[code] || code;
}
